$(function () {

    $('#CreditCardEdit input').on('input', function() {
        const cardno = $('#CreditCardEdit #cardno').val();
        const holdername = $('#CreditCardEdit #holdername').val();
        const expireYear = $('#CreditCardEdit #expire_year').val();
        const expireMonth = $('#CreditCardEdit #expire_month').val();
        const securitycode = $('#CreditCardEdit #securitycode').val();
        if ( cardno && holdername && expireYear && expireMonth && securitycode ) {
            $('#CreditCardEdit .submit-area a').removeClass('disabled');
        } else {
            $('#CreditCardEdit .submit-area a').addClass('disabled');
        }
    });

    $('#CreditCardEdit .submit-area a').click(function() {
        $('#CreditCardEdit .submit-area a').addClass('disabled')
        doPurchase();
    });
});

function doPurchase() {
    var cardno = $('#CreditCardEdit #cardno').val();
    var expire = $('#CreditCardEdit #expire_year').val() + ( '00' + $('#CreditCardEdit #expire_month').val()).slice( -2 );
    var securitycode = $('#CreditCardEdit #securitycode').val();
    var holdername = $('#CreditCardEdit #holdername').val();
    var tokennumber = "";
    Multipayment.init(document.querySelector('#shop_id').getAttribute("data-id"));
    Multipayment.getToken({
        cardno : cardno,
        expire : expire,
        securitycode : securitycode,
        holdername : holdername,
        tokennumber : tokennumber
    }, function (response) {
        if (response.resultCode !== "000") {
            const tokenError = {
                "100": "カード番号をご入力ください",
                "101": "カード番号は数字のみご入力ください",
                "102": "カード番号は10-16桁でご入力ください",
                "110": "有効期限をご入力ください",
                "111": "有効期限は数字のみご入力ください",
                "112": "有効期限は6桁又は4桁でご入力ください",
                "113": "有効期限の月は1〜12でご入力ください",
                "121": "セキュリティコードは数字のみご入力ください",
                "122": "セキュリティコードの桁数が不正です",
                "131": "カード名義は半角英数字等でご入力ください",
                "132": "カード名義は50字以内でご入力ください",
                "901": "決済システムエラーが発生しました",
                "902": "処理が混み合っています"
            };
            if (response.resultCode in tokenError) {
                window.alert(tokenError[response.resultCode]);
            } else {
                window.alert('クレジットカードを認証できません。登録内容をご確認ください。\n' + response.resultCode);
            }
            $('#CreditCardEdit .submit-area a').removeClass('disabled');
        } else {
            // カード情報は念のため値を除去
            $('#CreditCardEdit #cardno').val('');
            $('#CreditCardEdit #expire_year').val('');
            $('#CreditCardEdit #expire_month').val('');
            $('#CreditCardEdit #securitycode').val('');
            $('#CreditCardEdit #holdername').val('');
            $('#CreditCardEdit #token').val(response.tokenObject.token);
            // スクリプトからフォームを submit
            document.getElementById("credit_card_edit_form").submit();
        }
    });
}